import * as cocoSsd from '@tensorflow-models/coco-ssd'
import { getDetector } from '../detectionProvider'

let sharedModel = null
let loadingPromise = null

export async function loadCocoSsd() {
    if (sharedModel) return sharedModel
    if (!loadingPromise) loadingPromise = cocoSsd.load()
    sharedModel = await loadingPromise
    return sharedModel
}

const PET_CLASSES = new Set([
    'cat',
    'dog',
    'bird',
    'horse',
    'sheep',
    'cow',
    'elephant',
    'bear',
    'zebra',
    'giraffe',
])

function createCocoDetector({ id, label, accent, title, onlyPets }) {
    let provider = null

    return {
        id,
        label,
        accent,

        async load() {
            // Uses the shared object-detector backend (YOLOv8, or coco-ssd
            // fallback) so the play tiles match tracking/line-crossing.
            provider = await getDetector()
        },

        async detect({ video, vw, vh }) {
            if (!provider || !vw || !vh) return null
            let results = await provider.detect(video, 20)
            results = results.filter((r) => r.score > 0.5)
            if (onlyPets) results = results.filter((r) => PET_CLASSES.has(r.class))
            const boxes = results.map((r) => ({
                x: r.bbox[0] / vw,
                y: r.bbox[1] / vh,
                w: r.bbox[2] / vw,
                h: r.bbox[3] / vh,
                label: `${r.class} ${Math.round(r.score * 100)}%`,
                score: r.score,
            }))
            // One row per detected class with its count (person: Yes (1), ...).
            const counts = {}
            results.forEach((r) => {
                counts[r.class] = (counts[r.class] || 0) + 1
            })
            const insights = Object.keys(counts).length
                ? Object.entries(counts).map(([cls, n]) => ({
                      label: cls,
                      value: `Yes (${n})`,
                  }))
                : [{ label: onlyPets ? 'Pets' : 'Objects', value: 'None' }]
            return {
                boxes,
                title,
                insights,
            }
        },

        reset() {},
        dispose() {
            provider = null
        },
    }
}

export function createObjectDetector() {
    return createCocoDetector({
        id: 'object',
        label: 'Object Detection',
        accent: '#3b82f6',
        title: 'Detected Objects',
        onlyPets: false,
    })
}

export function createPetDetector() {
    return createCocoDetector({
        id: 'pet',
        label: 'Pet Detection',
        accent: '#f59e0b',
        title: 'Detected Pets',
        onlyPets: true,
    })
}
